<template>
  <el-dialog
    title="详情"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @closed="$emit('close')"
  >
    <div class="content">
      <div class="content_left">
        <div class="item">
          <span class="item_title">组名：</span>
          <span class="item_text">{{ activeItem.tagGroupName }}</span>
        </div>

        <div class="item">
          <span class="item_title">平台：</span>
          <span class="item_text">
            {{ platforms.filter(item => item.id === activeItem.platformId)[0] ? platforms.filter(item => item.id === activeItem.platformId)[0].name : '' }}
          </span>
        </div>
      </div>
      <div class="content_right">
        <span class="right_title">标签：</span>
        <ul v-if="activeItem.tagInfo" class="right_content">
          <li v-for="item in activeItem.tagInfo" :key="item.type" class="content_li">
            <div>
              <span>标签类型：</span>
              <span class="li_title">{{ item.title }}</span><!-- :class="{allMiddle:item.actives.length === item.select.length}" -->
            </div>
            <div class="li_content">
              <span>标签值：</span>
              <span v-for="item1 in item.values" :key="item1.id" class="content_item">{{ item1.tagName }}</span>
            </div>
          </li>
          <span v-if="!activeItem.tagInfo.length" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 20px;">暂无标签</span>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { /* getAllLabelList */ } from '@/api/labelGroup.js'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  mixins: [convertToHump],
  props: {
    platforms: {
      type: Array,
      default() {
        return []
      }
    },
    activeItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: true,
      labelLists: [],
      datas: null
    }
  },
  created() {
    console.log(this.activeItem)
    this.getAllLabelList()
  },
  methods: {
    structuralAssembly() {
      const newArr = JSON.parse(this.activeItem.tagIds).map(item => item.id)
      const obj = {}
      for (let i = 0; i < this.labelLiists.length; i++) {
        const item = this.labelLiists[i]
        for (let l = 0; l < item.select.length; l++) {
          const item1 = item.select[l]
          if (newArr.includes(item1.id)) {
            if (obj[item.tagType]) {
              obj[item.tagType].actives.push(item1)
            } else {
              obj[item.tagType] = {
                ...item,
                actives: [item1]
              }
            }
          }
        }
      }
      return obj
    },
    async getAllLabelList() {
      /* const data = await getAllLabelList()
      this.labelLiists = this.convertToHump(data.data)
      this.datas = this.structuralAssembly() */
    }
  }
}
</script>

<style scoped lang="less">
.content{
  height: 350px;
  .content_left{
     .item{
       margin: 10px 0px;
       font-size: 16px;
       .item_title{
           width: 100px;
           display: inline-block;
       }
       .item_text{
         display: inline-block;
       }
     }
  }

  .content_right{
      .right_title{
         font-weight: bold;
         color: black;
         font-size: 16px;
         margin-bottom: 8px;
         display: inline-block;
      }
      .right_ul{
        margin: 0px;
        padding: 0px;
        padding: 10px;
        padding-left: 30px;
        display: flex;
        flex-wrap: wrap;
        .ul_li{
          list-style-type: none;
          padding: 5px 15px;
          display: flex;
          align-items: center;
          border-radius: 16px;
          box-shadow: 0px 0px 3px rgb(100, 100, 100);
          margin: 5px;
          .li_text{

          }
          i{
             margin-left: 9px;
             font-size: 16px;
             cursor: pointer;
          }
        }
      }

      .right_content{
        list-style: none;
        margin: 0px;
        padding: 8px 0px;
        overflow: auto;
        height: 274px;
        box-shadow: 0px 0px 2px rgb(109, 109, 109);
        padding-left: 6px;
        position: relative;
        .content_li{
          margin: 13px 0px;
          .li_title{
                padding: 5px 10px;
                margin: 4px;
                display: inline-block;
              &.allMiddle{
                  box-shadow: 0px 0px 2px #626262;
                  border-radius: 11px;
                  display: inline-block;
              }
          }
          .li_content{
            .content_item{
                padding: 5px 10px;
                box-shadow: 0px 0px 2px #626262;
                border-radius: 11px;
                margin: 4px;
                display: inline-block;
            }
          }
        }
      }
  }
}
</style>
